import React, { useState, useEffect } from "react";
import {
  managementModalStyle,
  StyledModal,
} from "pages/PatientOverview/styles";
import {
  Box,
  TextField,
  Button,
  Autocomplete,
  Grid,
  CircularProgress,
  Typography,
} from "@mui/material";
import { MONTH_HISTORIC_OPTIONS, MONTHS_NAMES } from "constants/dates";
import { getElegibleEvents } from "repositories/elegibleEventsApi";
import { enqueueSnackbar } from "notistack";

const DownloadCsvModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: any;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    startMonth: new Date().getMonth(),
    startYear: new Date().getFullYear(),
    endMonth: new Date().getMonth(),
    endYear: new Date().getFullYear(),
  });

  const downloadCSV = (array: any) => {
    // Convert array to CSV string
    const csvContent = array.map((row: any) => row.join(",")).join("\n");

    // Create a Blob with the CSV content
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // Create a temporary link to download the CSV file
    const link = document.createElement("a");
    link.href = url;
    link.download = "data.csv";
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      const startDate = new Date(
        Number(formData.startYear),
        Number(formData.startMonth),
        1
      ).toISOString();
      const endDate = new Date(
        Number(formData.endYear),
        Number(formData.endMonth + 1),
        0
      ).toISOString();
      const events = await getElegibleEvents(endDate, startDate);
      const ACTIVITY_LOG_TARGET = "16";
      const dataArray = [
        [
          "Patient Name",
          "Clinician name",
          "Activities",
          "Target activities",
          "Start date",
          "End date",
          "Status",
        ],
      ];
      events.forEach((event: any) => {
        dataArray.push([
          event.patientName,
          event.clinicianName,
          event.loggedActivities || 0,
          ACTIVITY_LOG_TARGET,
          event.startDate.slice(0, 10),
          event.endDate.slice(0, 10),
          event.status,
        ]);
      });
      downloadCSV(dataArray);
      enqueueSnackbar("CSV Downloaded", { variant: "success" });
    } catch (error: any) {
      enqueueSnackbar(error.message, { variant: "error" });
    }
    setIsLoading(false);
    setIsOpen(false);
  };
  return (
    <StyledModal
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <Box sx={{ ...managementModalStyle }}>
        <Grid container xs={12}>
          <Typography variant="h4" sx={{ mb: 2, fontFamily: "SofiaPro" }}>
            Download CSV
          </Typography>
          <Grid item xs={12} style={{ marginRight: "10px", display: "flex" }}>
            <Autocomplete
              disablePortal
              disableClearable={true}
              id="combo-box-demo"
              getOptionDisabled={(option) => Boolean(option.disabled)}
              options={MONTH_HISTORIC_OPTIONS}
              sx={{ width: 300, mr: 2 }}
              onChange={(e, value: any) => {
                setFormData({
                  ...formData,
                  startMonth: value.month,
                  startYear: value.year,
                });
              }}
              defaultValue={{
                label: `${
                  MONTHS_NAMES[formData.startMonth]
                }-${formData.startYear.toString()}`,
                disabled: false,
                month: formData.startMonth.toString(),
                year: formData.startYear.toString(),
              }}
              renderInput={(params) => (
                <TextField {...params} label="Start month" />
              )}
            />
            <Autocomplete
              disablePortal
              disableClearable={true}
              id="combo-box-demo"
              getOptionDisabled={(option) => Boolean(option.disabled)}
              options={MONTH_HISTORIC_OPTIONS}
              sx={{ width: 300 }}
              onChange={(e, value: any) => {
                setFormData({
                  ...formData,
                  endMonth: value.month,
                  endYear: value.year,
                });
              }}
              defaultValue={{
                label: `${
                  MONTHS_NAMES[formData.endMonth]
                }-${formData.endYear.toString()}`,
                disabled: false,
                month: formData.endMonth.toString(),
                year: formData.endYear.toString(),
              }}
              renderInput={(params) => (
                <TextField {...params} label="End month" />
              )}
            />
          </Grid>
          <Grid
            sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
          >
            <Button
              disabled={isLoading}
              sx={{ mt: 2, ml: 2, mr: 2 }}
              onClick={() => {
                setIsOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              disabled={isLoading}
              sx={{ mt: 2 }}
              onClick={handleDownload}
            >
              {isLoading ? <CircularProgress size={20} /> : "Download"}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </StyledModal>
  );
};

export default DownloadCsvModal;
